import React, { Component } from 'react';
import BrokerProfile from './User/Broker/BrokerProfile';
import AgencyProfile from './User/Agencies/AgencyProfile';
import ClientProfile from './User/Client/ClientProfile';
import MemberProfile from './User/Member/MemberProfile';
class MyProfile extends Component {
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role=decodedToken.UserRoleName;
        return (
            <div>
                {role=== 'broker'?
                    <BrokerProfile  userPermandMasters={this.props.userPermandMasters} /> :
                    role==='agency'?
                    <AgencyProfile  userPermandMasters={this.props.userPermandMasters} />:
                    role==='member'?
                    <MemberProfile  userPermandMasters={this.props.userPermandMasters} />:
                    <ClientProfile  userPermandMasters={this.props.userPermandMasters} />
                }
            </div>
        )
    }
}
export default MyProfile;
